import * as UserConstants from '../actions/User/UserConstants';
import { UserState } from '../actions/User/UserTypes';

export default (state = UserConstants.DEFAULT_STATE, action: any): UserState => {
  switch (action.type) {
    case UserConstants.UserActionTypes.LOADED_USER_DETAILS:
      return { ...state, user_details: action.payload };
    default:
      return state;
  }
};
